import { WaterMeasurementProtocol } from "types/waterMeasurementProtocol/waterMeasurementProtocol.type";
import { WaterMeasurementProtocolStatus } from "types/waterMeasurementProtocol/waterMeasurementProtocol.helpers";
import { usePreviewPdf } from "hooks/usePreviewPdf";
import {
  FilePreviewSmall,
  InspectionPDFPreviewSmall,
  PendingPDFCardSmall,
} from "components/FilePreviewSmall";
import { getFileNameNew } from "helpers/file";
import { Headline5 } from "components/typography/Headline5";

type Props = {
  protocol: WaterMeasurementProtocol;
};

export const WaterMeasurementProtocolItem = ({ protocol }: Props) => {
  const { previewPdf, isLoading } = usePreviewPdf();

  return (
    <div>
      <div className="flex flex-col space-y-2">
        <Headline5 className="mb-2">
          {`Vattenprovtagning - ${protocol.separator.identifier}`}
        </Headline5>
        {protocol.status === WaterMeasurementProtocolStatus.ReportCompiled ? (
          <InspectionPDFPreviewSmall
            onClick={() =>
              previewPdf(
                `/water-measurement-protocol/${protocol.id}/preview-pdf`,
              )
            }
            inspectionName="provtagningsprotokoll.pdf"
            isLoading={isLoading}
          />
        ) : (
          <PendingPDFCardSmall
            title="Protokollet genereras automatiskt"
            subtitle="Slutför sammanställningen för att skapa dokumentet"
          />
        )}
        {[...(protocol.labFiles ?? []), ...(protocol.otherFiles ?? [])].map(
          (item) => (
            <FilePreviewSmall
              key={item.id}
              url={item.url}
              name={getFileNameNew(item)}
            />
          ),
        )}
      </div>
    </div>
  );
};
